export default __webpack_public_path__ + "static/media/parking-brake.f46f0344.png";